import { PropTypes } from 'prop-types';

const monthName = (name) => {
  switch (true) {
    case name === 1:
      return "January";
    case name === 2:
      return "February";
    case name === 3:
      return "March";
    case name === 4:
      return "April";
    case name === 5:
      return "May";
    case name === 6:
      return "June";
    case name === 7:
      return "July";
    case name === 8:
      return "August";
    case name === 9:
      return "September";
    case name === 10:
      return "October";
    case name === 11:
      return "November";
    case name === 12:
      return "December";
    default:
      return name;
  }
};

monthName.propTypes = {
  name: PropTypes.string
}

export default monthName;
